import { Grid, IconButton, Tooltip } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { useStore } from "../../../../../../utils/useStore";
import ConfirmationDialog from "../../../../../UI/AcxConfirmationDialog";
import { CustomControlItem } from "../../../../../UI/AcxTable/AcxControlledTable";
import {
    LoadSampleFilesTask,
    SourceFilesStepStore,
} from "../../Stores/SourceFilesStepStore";
import SourceFilesTable from "../SourceFilesTable";
import DirectoryTable from "./DirectoryTable";
import { AuthStore } from "stores/AuthStore";

interface OwnProps {}

type Props = OwnProps;

const SourceFilesStep: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = observer((props) => {
    const store = useStore(SourceFilesStepStore);
    const auth = useStore(AuthStore);
    console.log("source file step function executing");
    store.orgSelectStore.selectOrg(auth.orgStore.selectedOrganization);

    const sourceFileTableControls: CustomControlItem[] = [
        {
            controlElement: (
                <Tooltip title={"Refresh"} placement={"top"}>
                    <IconButton onClick={() => store.refresh?.()} size="large">
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            ),
            xs: 1,
            sm: 1,
            md: 1,
            lg: 1,
            xl: 1,
        },
    ];

    return (
        <>
            <ConfirmationDialog
                onClose={store.closeSampleFileDialog}
                title={"Files"}
                maxWidth={"xl"}
                errorMessage={store.getTaskError(LoadSampleFilesTask)?.message}
                noControls
                isOpen={store.showSampleFilesDialog}
                content={
                    <SourceFilesTable
                        tableStoreFragment={store.filesDialogtableStore}
                        enablePaging
                        controls={sourceFileTableControls}
                        loading={store.getTaskLoading(LoadSampleFilesTask)}
                        metaLabels={store.metaLabels}
                    />
                }
            />

            <Grid
                container
                item
                xs={12}
                direction={"row"}
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
                style={{ height: "100%" }}
            >
                <Grid item xs={12} style={{ height: "100%" }}>
                    <DirectoryTable />
                </Grid>
            </Grid>
        </>
    );
});

export default SourceFilesStep;
